import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const email = sessionStorage.getItem('email');
    const userName = sessionStorage.getItem('userName');

    if (email && userName && email !== 'undefined' && userName !== 'undefined') {
        return children;
    }

    return <Navigate to="/" />;

};

export default ProtectedRoute;
